import { CommonModule, DatePipe } from '@angular/common';
import { Component } from '@angular/core';
import { ApiService } from '../../core/services/api.service';
import { PermissionService } from '../../features/settings/rolesPersmission/permission.service';
import { insightsService } from './insightsService';
import { expandCollapse } from './accordion.animations';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { finalize } from 'rxjs';
import { FormsModule } from '@angular/forms';
import { log } from 'echarts/types/src/util/log.js';

interface DailyStoreTraffic {
  as_companyname: string;
  report_date: string; // The date comes in as an ISO string
  total_users: number;
}
interface TrafficData {
  store_name: string;
  category: string;
  total_users: number;
  total_revenue?: number; // Kept for potential future use
}
interface StorePerformanceData {
  New_Target: number;
  New_Units: number;
  Period: string;
  Total_Target: number;
  Total_Units: number;
  /** A date-time string in ISO 8601 format (e.g., "2025-08-31T00:00:00.000Z") */
  UsedEndDate: string;
  /** A date-time string in ISO 8601 format (e.g., "2025-08-01T00:00:00.000Z") */
  UsedStartDate: string;
  Used_Target: number;
  Used_units: number;
  storename: string;
}
interface ProcessedReportData {
  [key: string]: StorePerformanceData;
}
interface SalesGrossData {
  GrandTotal_BackGross: number;
  GrandTotal_Budget_BackGross: number;
  GrandTotal_Budget_FrontGross: number;
  GrandTotal_FrontGross: number;
  GrandTotal_Pace_BG: number;
  GrandTotal_Pace_FG: number;
  GrandTotal_Var_New: number;
  GrandTotal_Var_Used: number;
  Period: string;
  StoreName: string;
  Total_BackGross_New: number;
  Total_BackGross_Used: number;
  Total_Budget_New_BackGross: number;
  Total_Budget_New_FrontGross: number;
  Total_Budget_Used_BackGross: number;
  Total_Budget_Used_FrontGross: number;
  Total_FrontGross_New: number;
  Total_FrontGross_Used: number;
  Total_Pace_BG_New: number;
  Total_Pace_BG_Used: number;
  Total_Pace_FG_New: number;
  Total_Pace_FG_Used: number;
  Total_Var_BackGross_New: number;
  Total_Var_BackGross_Used: number;
  Total_Var_FrontGross_New: number;
  Total_Var_FrontGross_Used: number;
  endDate: string; // Or Date if you plan to parse it
  startDate: string; // Or Date if you plan to parse it
  storeid: number;
}
interface ProcessedGrossData {
  [key: string]: SalesGrossData;
}

interface Vehicle {
  AI_YEAR: number;
  AI_MAKE: string;
  AI_MODEL: string;
  AI_STOCK: string;
  AI_STORENAME: string;
  AI_VIN: string;
  AI_STOCK_TYPE: string;
  AI_MILES: number;
  AI_COLOR: string;
  AI_STATUS: string;
  AI_AGE: number;
  AI_LIST_PRICE: number;
  // Add other properties as needed
}
@Component({
  selector: 'app-insights',
  imports: [CommonModule,FormsModule],
  templateUrl: './insights.html',
  styleUrl: './insights.scss',
  animations: [expandCollapse],
})
export class Insights {
  categories: any[] = [];
  userInfo: any;
  userRole: any;
  userStores: any;
  questionsByCategory: any;
  userGrp: any;
  loading = false;
  startDate = new Date();
  endDate = new Date();
  trafficData: DailyStoreTraffic[] = [];
  dateRange: string = 'Loading...';
  storePerformanceData: any;
  // Property to hold the structured report data for easy access in the template
  reportData: { [key: string]: StorePerformanceData } = {};

  // A property to hold the raw HTML response if you still need it for other purposes
  finalAnswerHtml: string = '';
  // NEW: Property to hold the question that the user has clicked on
  selectedQuestion: any = null;
  finalHtmlContent: SafeHtml = 'Loading...';
  constructor(
    private apisrvc: ApiService,
    private srvc: insightsService,
    private sanitizer: DomSanitizer
  ) {
    this.userInfo = JSON.parse(localStorage.getItem('userInfo')!);
    this.userRole = this.userInfo.user_Info.roleid;
    this.userGrp = this.userInfo.group;
    this.userStores = this.userInfo.user_Info.ustores;
    this.startDate.setDate(1); // Set to first day of the month
  }

  ngOnInit() {
    this.loading = true;
    this.srvc.getCategories().subscribe((categories) => {
      this.srvc.getQuestionsByRole(this.userRole).subscribe((questions) => {
        const questionCategoryIds = new Set(questions.map((q) => q.CategoryId));
        this.categories = categories
          .filter((category) => questionCategoryIds.has(category.TWL_ID))
          .map((category) => ({ ...category, expanded: false }));
        this.questionsByCategory = questions.reduce((acc, question) => {
          acc[question.CategoryId] = acc[question.CategoryId] || [];
          acc[question.CategoryId].push(question);
          return acc;
        }, {} as { [key: number]: typeof questions });
        this.loading = false;
      });
    });
  }


  insiteIndex : any;
  toggleAccordion(index: number): void {
    // this.insiteIndex = -1;
    this.insiteIndex = index;
    
    this.categories[index].expanded = !this.categories[index].expanded;
    console.log("clicked"  ,index);
    
  }


  setDefaultAccordionByKey(key: string) {

    if (!this.categories || this.categories.length === 0) {
      const interval = setInterval(() => {
        if (this.categories && this.categories.length > 0) {
          clearInterval(interval);
          this.openMatchingAccordion(key);
        }
      }, 200);
    } else {
      this.openMatchingAccordion(key);
    }
  }

  private openMatchingAccordion(key: string) {
    const index = this.categories.findIndex(cat =>
      key == 'salesmtd' || key == 'sales'
        ? cat.TWL_NAME?.toLowerCase().includes('sales')
        : key == 'inventory'
        ? cat.TWL_NAME?.toLowerCase().includes('inventory')
        : key == 'CIT'
        ? cat.TWL_NAME?.toLowerCase().includes('cit')
        : key == 'Web Traffic'
        ? cat.TWL_NAME?.toLowerCase().includes('web traffic')
        : false
    );

    if (index !== -1) {
      this.toggleAccordion(index);
    } else {
      console.warn("⚠️ No matching category found for key:", key, "Available categories:", this.categories);
    }
  }



  closeAllAccordions(): void {
    this.categories.forEach((c, i) => {
      this.insiteIndex = -1;
      console.log(`🔒 Closed accordion at index ${this.insiteIndex}`);
      // if (c.expanded) {
      //   c.expanded = false;
      //   console.log(`🔒 Closed accordion at index ${i}`);
      // }
    });
  }

  /** ✅ Public method to close a specific accordion */
  closeAccordion(index: number): void {
    if (this.categories[index]) {
      this.categories[index].expanded = false;
      console.log(`🔒 Closed accordion at index ${index}`);
    }
  }




  // UPDATED: This function now handles toggling and setting the selected question
  onQuestionClick(question: any, event: MouseEvent) {
    event.stopPropagation(); // prevent accordion toggle

    // If the user clicks the same question again, hide the answer (toggle)
    if (this.selectedQuestion === question) {
      this.selectedQuestion = null;
      return; // Stop further execution
    }

    // Set the newly clicked question as the selected one
    this.selectedQuestion = question;

    // The rest of your logic to fetch/process the answer
    switch (question.QuestionText) {
      case 'Sales MTD':
        this.salesMTD(question);
        break;
      case ' On what days I get the most users?':
        console.log('User Count');
        this.web1(question);
        break;
      case 'Compare users from organic search vs paid search':
        this.web2(question);
        break;
      case 'Sales Trend':
        this.salesReport(question);
        break;
        case 'Sales Gross Report':
          this.saleGrossReport(question);
          break;
        case 'Inventory Summary':
          this.inventorySummary(question);
          break
      default:
        console.log('Handling default query');

      // Handle other questions here
    }
  }

  salesMTD(question: any) {
    this.loading = true;

    console.log('Sales MTD clicked');

    const startDateStr = this.formatDate(this.startDate);
    const endDateStr = this.formatDate(this.endDate);
    // const startDateStr = '2025-08-01';
    // const endDateStr = '2025-08-31';

    const userStoresStr = this.userStores;

    let rawQuery = question.Query;
    rawQuery = rawQuery.replace('{{startDate}}', `'${startDateStr}'`);
    rawQuery = rawQuery.replace('{{endDate}}', `'${endDateStr}'`);
    rawQuery = rawQuery.replace('{{userStores}}', `'${userStoresStr}'`);

    const queryPayload = { query: rawQuery };

    console.log(
      'Executing Sales MTD query for user group',
      this.userGrp,
      ':',
      queryPayload
    );

    this.srvc.postQueryByUserGroup(this.userGrp, queryPayload).subscribe({
      next: (response) => {
        console.log(
          'Sales MTD Query response for user group',
          this.userGrp,
          ':',
          response.response
        );

        const allStoresData = response.response.find(
          (r: any) => r.storename === 'ALL STORES'
        );
        if (!allStoresData) {
          console.error('"ALL STORES" record not found in the response.');
          this.loading = false;
          return;
        }

        // Calculations remain the same
        const totalActualUnits = allStoresData.Total_Units;
        const totalBudgetUnits = allStoresData.Total_Target;
        const variance = totalActualUnits - totalBudgetUnits;

        let overallStatus: string;
        let aheadBehind: string;

        if (variance >= 0) {
          overallStatus = `<span class="status-good">exceeding</span>`;
          aheadBehind = `<span class="status-good">Ahead</span>`;
        } else {
          overallStatus = `<span class="status-bad">trailing</span>`;
          aheadBehind = `<span class="status-bad">Behind</span>`;
        }
        //const overallStatus = variance >= 0 ? 'exceeding' : 'trailing';
        //  const aheadBehind = variance >= 0 ? 'Ahead' : 'Behind';
        const totalUnitVariance = Math.abs(variance);
        let totalUnitVariancePercent = '0.0';
        if (totalBudgetUnits > 0) {
          totalUnitVariancePercent = (
            (totalActualUnits / totalBudgetUnits) *
            100
          ).toFixed(1);
        }
        const formattedStartDate = this.formatResponseDate(
          allStoresData.UsedStartDate
        );
        const formattedEndDate = this.formatResponseDate(
          allStoresData.UsedEndDate
        );

        // **** MODIFICATION IS HERE ****

        // Step 4.1: Create the static table header
        const tableHeader = `
       
            <thead>
                <tr style="color: #000; font-weight: bold;">
                    <th style="text-align: left; padding: 6px;">&nbsp;</th>
                    <th style="padding: 6px;">Total</th>
                    <th style="padding: 6px;">New</th>
                    <th style="padding: 6px;">Used</th>
                </tr>
            </thead>
        `;

        // Step 4.2: Create the table body rows (as before)
        const tableBodyRows = response.response
          .filter((store: any) => store.storename == 'ALL STORES')
          .map(
            (store: any) =>
            `<tr>
                <td>Unit Sales</td>
                <td>${store.Total_Units}</td>
                <td>${store.New_Units}</td>
                <td>${store.Used_units}</td>
              </tr>
              <tr>
                <td>Target</td>
                <td>${store.Total_Target}</td>
                <td>${store.New_Target}</td>
                <td>${store.Used_Target}</td>
              </tr>` 
                 )
          .join('');

        // Step 4.3: Combine header and body rows into the full table content
        const fullTableContent =
          tableHeader + `<tbody>${tableBodyRows}</tbody>`;

        // Step 5: Replace placeholders in the answer string
        let finalAnswer = question.Answer;
        // (All other replacements remain the same)
        finalAnswer = finalAnswer.replace(
          '{{ startDate }}',
          `<strong>${formattedStartDate}</strong>`
        );
        finalAnswer = finalAnswer.replace(
          '{{ currentDate }}',
          `<strong>${formattedEndDate}</strong>`
        );
        finalAnswer = finalAnswer.replace(
          '{{ overallStatus }}',
          `<strong>${overallStatus}</strong>`
        );
        finalAnswer = finalAnswer.replace(
          new RegExp('{{ totalUnitVariance }}', 'g'),
          `<strong>${totalUnitVariance}</strong>`
        );
        finalAnswer = finalAnswer.replace(
          '{{ totalUnitVariancePercent }}',
          `<strong>${totalUnitVariancePercent}</strong>`
        );
        finalAnswer = finalAnswer.replace(
          '{{ aheadBehind }}',
          `<strong>${aheadBehind}</strong>`
        );
        finalAnswer = finalAnswer.replace(
          '{{ totalBudgetUnits }}',
          totalBudgetUnits
        );
        finalAnswer = finalAnswer.replace(
          '{{ totalActualUnits }}',
          totalActualUnits
        );

        // Replace the entire table's content (tbody with the ngFor) with our new full table content
        // This regex finds the <table> tag and replaces everything inside it.
        finalAnswer = finalAnswer.replace(
          /<table>.*?<\/table>/s,
          `<table>${fullTableContent}</table>`
        );

        question.Answer = finalAnswer;
        this.loading = false;
      },
      error: (err) => {
        console.error('Error executing Sales MTD query:', err);
        this.loading = false;
      },
    });
  }

  salesReport(question: any) {
    this.loading = true;
    let rawQuery = question.Query.replace(
      '{{userStores}}',
      `'${this.userStores}'`
    );
    const queryPayload = { query: rawQuery };

    this.srvc
      .postQueryByUserGroup(this.userGrp, queryPayload)
      .pipe(
        // This operator ensures that this code block runs when the API call
        // is complete, whether it succeeds or fails.
        finalize(() => {
          this.loading = false;
        })
      )
      .subscribe({
        next: (response) => {
          // Store the static HTML if needed, though we won't use it for rendering the dynamic part

          const filteredData: StorePerformanceData[] = response.response.filter(
            (item: StorePerformanceData) => item.storename === 'ALL STORES'
          );

          // **This is the key change: Process the data into a structured object**
          const processedData: { [key: string]: StorePerformanceData } = {};
          filteredData.forEach((item) => {
            // Use the "Period" as the key (e.g., 'YTD', 'MTD')
            processedData[item.Period] = item;
          });

          console.log('Processed Report Data for template:', processedData);
          this.generateReport(question, processedData);
        },
        error: (err: any) => {
          console.error('Error executing query:', err);
        },
      });
  }
  saleGrossReport(question: any) {
    this.loading = true;
    let rawQuery = question.Query.replace(
      '{{userStores}}',
      `'${this.userStores}'`
    );
    const queryPayload = { query: rawQuery };

    this.srvc
      .postQueryByUserGroup(this.userGrp, queryPayload)
      .pipe(
        // This operator ensures that this code block runs when the API call
        // is complete, whether it succeeds or fails.
        finalize(() => {
          this.loading = false;
        })
      )
      .subscribe({
        next: (response) => {
         console.log('Gross Report Data:', response);
          const filteredData: SalesGrossData[] = response.response.filter(
            (item: SalesGrossData) => item.StoreName === 'ALL STORES'
          );

          // **This is the key change: Process the data into a structured object**
          const processedData: { [key: string]: SalesGrossData } = {};
          filteredData.forEach((item) => {
            // Use the "Period" as the key (e.g., 'YTD', 'MTD')
            processedData[item.Period] = item;
          });

          console.log('Processed Gross Data for template:', processedData);

          question.Answer = this.populateTemplate(processedData, question.Answer);
         // console.log('Selected Question Answer:', question.Answer);
        },
        error: (err: any) => {
          console.error('Error executing query:', err);
        },
      });
  }
  web1(question: any) {
    this.loading = true;
    let rawQuery = question.Query.replace(
      '{{userStores}}',
      `'${this.userStores}'`
    );
    const queryPayload = { query: rawQuery };

    this.srvc
      .postQueryByUserGroup(this.userGrp, queryPayload)
      .pipe(
        // This operator ensures that this code block runs when the API call
        // is complete, whether it succeeds or fails.
        finalize(() => {
          this.loading = false;
        })
      )
      .subscribe({
        next: (response) => {
          const trafficData: DailyStoreTraffic[] = response.response.filter(
            (item: DailyStoreTraffic) => item.as_companyname === 'ALL Stores'
          );

          let dateRange = 'No date range available';
          if (trafficData.length > 0) {
            const dates = trafficData.map((d) => new Date(d.report_date));
            const minDate = new Date(
              Math.min(...dates.map((date) => date.getTime()))
            );
            const maxDate = new Date(
              Math.max(...dates.map((date) => date.getTime()))
            );
            const datePipe = new DatePipe('en-US');
            dateRange = `${datePipe.transform(
              minDate,
              'MMM d'
            )}–${datePipe.transform(maxDate, 'MMM d, yyyy')}`;
          }

          const tableBodyRows = trafficData
            .sort((a, b) => b.total_users - a.total_users)
            .map((item) => {
              const datePipe = new DatePipe('en-US');
              const formattedDay = datePipe.transform(item.report_date, 'EEEE');
              const formattedDate = datePipe.transform(
                item.report_date,
                'MMM d, yyyy'
              );
              const formattedUsers = item.total_users.toLocaleString();
              return `<tr>
                      <td>${formattedDay}</td>
                      <td>${formattedDate}</td>
                      <td class="users-col">${formattedUsers}</td>
                    </tr>`;
            })
            .join('');

          let finalAnswer = question.Answer;
          finalAnswer = finalAnswer.replace('{{ dateRange }}', dateRange);
          finalAnswer = finalAnswer.replace(
            /<tbody>.*?<\/tbody>/s,
            `<tbody>${tableBodyRows}</tbody>`
          );

          this.finalHtmlContent =
            this.sanitizer.bypassSecurityTrustHtml(finalAnswer);
          question.Answer = finalAnswer;
        },
        error: (err) => {
          console.error('Error executing query:', err);
          const errorHtml = `<div class="report-widget"><p>Error loading data.</p></div>`;
          this.finalHtmlContent =
            this.sanitizer.bypassSecurityTrustHtml(errorHtml);
          question.Answer = errorHtml;
        },
      });
  }

  web2(question: any) {
    this.loading = true;
    let rawQuery = question.Query.replace(
      '{{userStores}}',
      `'${this.userStores}'`
    );
    const queryPayload = { query: rawQuery };

    this.srvc
      .postQueryByUserGroup(this.userGrp, queryPayload)
      .pipe(
        // This operator ensures that this code block runs when the API call
        // is complete, whether it succeeds or fails.
        finalize(() => {
          this.loading = false;
        })
      )
      .subscribe({
        next: (response) => {
          const trafficData: TrafficData[] = response.response || [];
          let finalAnswer = question.Answer;

          // A map to connect API category names to HTML placeholder variables
          const placeholderMap: { [key: string]: string } = {
            'Paid Search': '{{paid_search_users}}',
            'Organic Search': '{{organic_search_users}}',
            Direct: '{{direct_users}}',
            Referral: '{{referral_users}}',
            Display: '{{display_users}}',
            Unassigned: '{{unassigned_users}}',
          };

          // Process the API response and replace placeholders
          trafficData.forEach((item) => {
            const placeholder = placeholderMap[item.category];
            if (placeholder) {
              const formattedValue = this.formatNumber(item.total_users);
              finalAnswer = finalAnswer.replace(placeholder, formattedValue);
            }
          });

          // Fallback: Replace any remaining (unfilled) placeholders with '0'
          finalAnswer = finalAnswer.replace(/\{\{[a-z_]+\}\}/g, '0');

          // Update the question object itself
          question.Answer = finalAnswer;

          // Sanitize the final HTML for safe rendering in the template
          this.finalHtmlContent =
            this.sanitizer.bypassSecurityTrustHtml(finalAnswer);
        },
        error: (err: any) => {
          console.error('Error executing query:', err);
          const errorHtml = `<div class="p-4 text-center text-red-500">Error loading data.</div>`;
          question.Answer = errorHtml;
          this.finalHtmlContent =
            this.sanitizer.bypassSecurityTrustHtml(errorHtml);
        },
      });
  }
  formatDate(date: Date): string {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  formatResponseDate(dateString: string): string {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      month: 'long',
      day: 'numeric',
      year: 'numeric',
    });
  }
  private formatCurrency(num: number): string {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(num);
  }
  private formatNumber(num: number): string {
    if (num >= 10000) {
      return (num / 1000).toFixed(1) + 'K';
    }
    if (num >= 1000) {
      if (num % 1000 !== 0) {
        return (num / 1000).toFixed(1) + 'K';
      }
      return num / 1000 + 'K';
    }
    return num.toString();
  }

  /**
   * Orchestrates the data processing and HTML population.
   * It takes the processed data and the question object, populates the template,
   * and updates the component's state.
   */
  private generateReport(question: any, processedData: ProcessedReportData) {
    // The initial HTML template is question.Answer
    const htmlTemplate = question.Answer;

    // The core function that performs calculations and replacements
    const finalHtml = this.populateSalesReport(processedData, htmlTemplate);

    // Update the question object as requested
    question.Answer = finalHtml;

    // Also update a local property to display it directly in this component's template
    this.finalAnswerHtml = finalHtml;

    console.log('Updated question.Answer with dynamic HTML.');
  }
  private populateSalesReport(
    data: ProcessedReportData,
    template: string
  ): string {
    let populatedHtml = template;

    // --- Data Extraction and Safeguards ---
    const ytd = data['YTD'];
    const pytd = data['PYTD'];
    const mtd = data['MTD'];
    const pmtd = data['PMTD'];
    const lastMonth = data['Last Month'];

    // If essential data is missing, return a message instead of a broken template.
    if (!ytd || !pytd || !mtd || !pmtd || !lastMonth) {
      return `<p class="p-4 text-orange-600">Error: Could not generate a complete report due to missing time period data (e.g., YTD, PYTD) Here.</p>`;
    }

    // --- Analysis Calculations ---

    // 1. Year-over-Year Growth Analysis
    const ytdUnits = ytd.Total_Units;
    const pytdUnits = pytd.Total_Units;
    const yoyChange = ytdUnits - pytdUnits;
    const yoyPercentage =
      pytdUnits > 0 ? ((yoyChange / pytdUnits) * 100).toFixed(1) : '100.0';
    const yoyIndicator = yoyChange >= 0 ? '<span class="status-good">increase</span>' : '<span class="status-bad">decrease </span';
    const yoyColor = yoyChange >= 0 ? 'text-green-600' : 'text-red-600';

    // 2. Monthly Momentum Analysis
    const mtdUnits = mtd.Total_Units;
    const pmtdUnits = pmtd.Total_Units;
    const mtmChange = mtdUnits - pmtdUnits;
    const mtmPercentage =
      pmtdUnits > 0 ? ((mtmChange / pmtdUnits) * 100).toFixed(1) : '100.0';
    const mtmIndicator = mtmChange >= 0 ? '<span class="status-good">ahead</span>' : '<span class="status-bad">behind </span>';
    const mtmColor = mtmChange >= 0 ? 'text-green-600' : 'text-red-600';

    // 3. Progress to Target Calculations
    const mtdTarget = mtd.Total_Target || 0;
    const ytdTarget = ytd.Total_Target || 0;
    const mtdPacePercentage =
      mtdTarget > 0 ? ((mtdUnits / mtdTarget) * 100).toFixed(1) : '0.0';
    const ytdProgressPercentage =
      ytdTarget > 0 ? ((ytdUnits / ytdTarget) * 100).toFixed(1) : '0.0';

    // --- Helper for Number and Date Formatting ---
    const formatNum = (num: number | null | undefined) =>
      (num || 0).toLocaleString();
    const formatDate = (dateStr: string | null | undefined) =>
      dateStr ? new Date(dateStr).toISOString().split('T')[0] : 'N/A';

    // --- String Replacements ---
    const replacements = {
      '{{StoreName}}': ytd.storename,
      // Analysis Section
      '{{YTD_TotalUnits}}': formatNum(ytdUnits),
      '{{Analysis_YTD_vs_PYTD_Color}}': yoyColor,
      '{{Analysis_YTD_vs_PYTD_Indicator}}': yoyIndicator,
      '{{Analysis_YTD_vs_PYTD_Percentage}}': Math.abs(
        parseFloat(yoyPercentage)
      ).toFixed(1),
      '{{PYTD_TotalUnits}}': formatNum(pytdUnits),
      '{{MTD_TotalUnits}}': formatNum(mtdUnits),
      '{{Analysis_MTD_vs_PMTD_Color}}': mtmColor,
      '{{Analysis_MTD_vs_PMTD_Indicator}}': mtmIndicator,
      '{{Analysis_MTD_vs_PMTD_Percentage}}': Math.abs(
        parseFloat(mtmPercentage)
      ).toFixed(1),
      '{{PMTD_TotalUnits}}': formatNum(pmtdUnits),
      '{{Analysis_MTD_Pace_Percentage}}': mtdPacePercentage,
      '{{MTD_TotalTarget}}': formatNum(mtdTarget),
      // YTD Card
      '{{YTD_StartDate}}': formatDate(ytd.UsedStartDate),
      '{{YTD_EndDate}}': formatDate(ytd.UsedEndDate),
      '{{YTD_TotalTarget}}': formatNum(ytdTarget),
      '{{YTD_ProgressPercentage}}': ytdProgressPercentage,
      // PYTD Card
      '{{PYTD_StartDate}}': formatDate(pytd.UsedStartDate),
      '{{PYTD_EndDate}}': formatDate(pytd.UsedEndDate),
      '{{PYTD_TotalTarget}}': formatNum(pytd.Total_Target),
      // Last Month Card
      '{{LastMonth_StartDate}}': formatDate(lastMonth.UsedStartDate),
      '{{LastMonth_EndDate}}': formatDate(lastMonth.UsedEndDate),
      '{{LastMonth_NewUnits}}': formatNum(lastMonth.New_Units),
      '{{LastMonth_NewTarget}}': formatNum(lastMonth.New_Target),
      '{{LastMonth_UsedUnits}}': formatNum(lastMonth.Used_units),
      '{{LastMonth_UsedTarget}}': formatNum(lastMonth.Used_Target),
      '{{LastMonth_TotalUnits}}': formatNum(lastMonth.Total_Units),
      '{{LastMonth_TotalTarget}}': formatNum(lastMonth.Total_Target),
    };

    // Loop through the replacements and apply them to the HTML string.
    for (const [placeholder, value] of Object.entries(replacements)) {
      // Use a global regex to replace all occurrences of the placeholder.
      populatedHtml = populatedHtml.replace(
        new RegExp(placeholder.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&'), 'g'),
        String(value)
      );
    }

    return populatedHtml;
  }
   /**
   * Populates an HTML template string by replacing placeholders with data.
   * @param processedData - A structured object with sales data keyed by period.
   * @param template - The HTML string containing placeholders like {{variable}}.
   * @returns The populated HTML string.
   */
   private populateTemplate(processedData: { [key: string]: SalesGrossData }, template: string): string {
    const mtdData = processedData['MTD'];
    const ytdData = processedData['YTD'];
    const pytdData = processedData['PYTD'];
    const lastMonthData = processedData['Last Month'];
    const pmtdData = processedData['PMTD'];

    if (!mtdData) {
        return "<p>MTD data is not available to generate the report.</p>";
    }

    const formatCurrency = (value: number | undefined | null): string => {
        if (value === null || value === undefined) return '$0.00';
        return value.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
    };

    // --- MTD Front Gross Calculations ---
    const mtdActualFg = mtdData.GrandTotal_FrontGross || 0;
    const mtdBudgetFg = mtdData.GrandTotal_Budget_FrontGross || 0;
    const mtdVarianceFg = mtdActualFg - mtdBudgetFg;
    const mtdPercentFg = mtdBudgetFg ? (mtdActualFg / mtdBudgetFg) * 100 : 0;

    // --- MTD Back Gross Calculations ---
    const mtdActualBg = mtdData.GrandTotal_BackGross || 0;
    const mtdBudgetBg = mtdData.GrandTotal_Budget_BackGross || 0;
    const mtdVarianceBg = mtdActualBg - mtdBudgetBg;
    const mtdPercentBg = mtdBudgetBg ? (mtdActualBg / mtdBudgetBg) * 100 : 0;

    // Using a simple object to map placeholders to their values
    const replacements: { [key: string]: string } = {
        '{{mtd_actual_front_gross}}': formatCurrency(mtdActualFg),
        '{{mtd_budget_front_gross}}': formatCurrency(mtdBudgetFg),
        '{{mtd_variance_front_gross}}': formatCurrency(mtdVarianceFg),
        '{{mtd_percent_front_gross}}': `${mtdPercentFg.toFixed(2)}%`,
        '{{mtd_status_front_gross}}': mtdVarianceFg >= 0 ? 'Ahead' : 'Behind',
        '{{mtd_status_class_front_gross}}': mtdVarianceFg >= 0 ? 'status-good' : 'status-bad',

        '{{mtd_actual_back_gross}}': formatCurrency(mtdActualBg),
        '{{mtd_budget_back_gross}}': formatCurrency(mtdBudgetBg),
        '{{mtd_variance_back_gross}}': formatCurrency(mtdVarianceBg),
        '{{mtd_percent_back_gross}}': `${mtdPercentBg.toFixed(2)}%`,
        '{{mtd_status_back_gross}}': mtdVarianceBg >= 0 ? 'Ahead' : 'Behind',
        '{{mtd_status_class_back_gross}}': mtdVarianceBg >= 0 ? 'status-good' : 'status-bad',

        '{{ytd_front_gross}}': formatCurrency(ytdData?.GrandTotal_FrontGross),
        '{{pytd_front_gross}}': formatCurrency(pytdData?.GrandTotal_FrontGross),
        '{{ytd_back_gross}}': formatCurrency(ytdData?.GrandTotal_BackGross),
        '{{pytd_back_gross}}': formatCurrency(pytdData?.GrandTotal_BackGross),

        '{{mtd_grand_total_front_gross}}': formatCurrency(mtdData.GrandTotal_FrontGross),
        '{{last_month_front_gross}}': formatCurrency(lastMonthData?.GrandTotal_FrontGross),
        '{{mtd_grand_total_back_gross}}': formatCurrency(mtdData.GrandTotal_BackGross),
        '{{last_month_back_gross}}': formatCurrency(lastMonthData?.GrandTotal_BackGross),

        '{{pmtd_front_gross}}': formatCurrency(pmtdData?.GrandTotal_FrontGross),
        '{{pmtd_back_gross}}': formatCurrency(pmtdData?.GrandTotal_BackGross),
    };

    let populatedTemplate = template;
    // Loop through the replacements and update the template string
    for (const key in replacements) {
        // We need to escape the curly braces as they are special characters in regex.
        const escapedKey = key.replace(/{/g, '\\{').replace(/}/g, '\\}');
        const regex = new RegExp(escapedKey, 'g');
        populatedTemplate = populatedTemplate.replace(regex, replacements[key]);
    }
    console.log('Populated Template:', populatedTemplate);
    return populatedTemplate;
  }

  stockNumber:any
    // Store the original template here to prevent mutation
    private originalAnswerTemplate: string | null = null;
    getStockData(question: any, currentStockNumber: string) {
      if (this.originalAnswerTemplate === null && question.Answer) {
        this.originalAnswerTemplate = question.Answer;
      }
      this.stockNumber = currentStockNumber;
      this.loading = true;
      let rawQuery = question.Query.replace(
        '{{userStores}}',
        `'${this.userStores}'`
      ).replace('{{stockno}}', `'${this.stockNumber}'`);
      const queryPayload = { query: rawQuery };
      this.srvc
        .postQueryByUserGroup(this.userGrp, queryPayload)
        .pipe(
          finalize(() => {
            this.loading = false;
          })
        )
        .subscribe({
          next: (response) => {
            const vehicles: Vehicle[] = response.response || [];
            let htmlToShow: string;

            if (vehicles.length === 0) {
              htmlToShow = `<p class="p-4 text-center">No vehicle found with stock number "${this.stockNumber}".</p>`;
            } else {
              if (this.originalAnswerTemplate === null) {
                console.error("Original answer template is missing!");
                return;
              }

              let processedTemplate = this.originalAnswerTemplate;
              const vehicle = vehicles[0];
              const placeholderMap: { [key: string]: string } = {
                '{{AI_YEAR}}': vehicle.AI_YEAR?.toString() || 'N/A',
                '{{AI_MAKE}}': vehicle.AI_MAKE || 'N/A',
                '{{AI_MODEL}}': vehicle.AI_MODEL || 'N/A',
                '{{AI_STOCK}}': vehicle.AI_STOCK || 'N/A',
                '{{AI_STORENAME}}': vehicle.AI_STORENAME || 'N/A',
                '{{AI_VIN}}': vehicle.AI_VIN || 'N/A',
                '{{AI_STOCK_TYPE}}': vehicle.AI_STOCK_TYPE || 'N/A',
                '{{AI_MILES}}': vehicle.AI_MILES?.toLocaleString() || 'N/A',
                '{{AI_COLOR}}': vehicle.AI_COLOR || 'N/A',
                '{{AI_STATUS}}': vehicle.AI_STATUS || 'N/A',
                '{{AI_AGE}}': vehicle.AI_AGE?.toString() || 'N/A',
                '{{AI_LIST_PRICE}}': vehicle.AI_LIST_PRICE?.toLocaleString('en-US', { style: 'currency', currency: 'USD' }) || 'N/A',
              };

              for (const placeholder in placeholderMap) {
                const value = placeholderMap[placeholder];
                processedTemplate = processedTemplate.replace(new RegExp(placeholder, 'g'), value);
              }
              htmlToShow = processedTemplate;
            }

            this.finalHtmlContent = this.sanitizer.bypassSecurityTrustHtml(htmlToShow);

            // --- SOLUTION: Store the result in a NEW property ---
            // This preserves the original question.Answer template for the next run.
            setTimeout(() => {
              question.Answer = this.finalHtmlContent;
          }, 1000);

          },
          error: (err) => {
            console.error('Error fetching stock data:', err);
            const errorHtml = `<p class="p-4 text-center text-danger">An error occurred while fetching stock data.</p>`;
            this.finalHtmlContent = this.sanitizer.bypassSecurityTrustHtml(errorHtml);

            // --- Also use the new property for errors ---
            setTimeout(() => {
              question.Answer = this.finalHtmlContent;
          }, 1000);
          }
        });
    }

    inventoryData: any[] = [];
  statusMessage: string = '';
  errorMessage: string = '';
  generationTimestamp: Date | null = null;

    inventorySummary(question: any) {
      this.loading = true;
         // Clear previous results
    this.inventoryData = [];
    this.errorMessage = '';
    this.statusMessage = '';
    this.generationTimestamp = null;
      let rawQuery = question.Query.replace(
        '{{userStores}}',
        `'${this.userStores}'`
      );
      const queryPayload = { query: rawQuery };

      this.srvc
        .postQueryByUserGroup(this.userGrp, queryPayload)
        .pipe(
          // This operator ensures that this code block runs when the API call
          // is complete, whether it succeeds or fails.
          finalize(() => {
            this.loading = false;
          })
        )
        .subscribe({
          next: (response) => {
          // --- THIS IS THE KEY ---
          // 1. Assign the data from the API to your component properties.
          const inventoryData: any[] = response.response || [];
         // --- KEY CHANGE ---
        // Call the helper function to generate the final HTML string.
        const finalHtml = this.generateReportHtml(inventoryData, response.message);

        // Assign the generated HTML string to question.Answer.
        // This is now ready for [innerHTML].
        question.Answer = finalHtml;

        // If you are also using a sanitized property, update it as well.
        // this.finalHtmlContent = this.sanitizer.bypassSecurityTrustHtml(finalHtml);


          },
          error: (err: any) => {
            // console.error('Error executing query:', err);
            // const errorHtml = `<div class="p-4 text-center text-red-500">Error loading data.</div>`;
            // question.Answer = errorHtml;
            // this.finalHtmlContent =
            //   this.sanitizer.bypassSecurityTrustHtml(errorHtml);
            console.error('Error executing query:', err);
            // Set the error message property. The template will display it.
            this.errorMessage = 'An error occurred while loading the report.';
          }
        });
    }

    private generateReportHtml(data: any[], statusMessage: string): string {


      // Start building the HTML shell
      let html = `
        <div class="report-container">
          <header class="report-header">
            <h5>Inventory Aging Report-Units</h5>
          </header>
      `;

      // Check if there is data to display
      if (!data || data.length === 0) {
        // If no data, append the "no data" message and close the container
        html += `
          <div class="no-data">
            <p>No inventory data found to display.</p>
          </div>
        </div>`;
      } else {
        // If data exists, build the table
        // Use map() to transform each data object into a <tr> string,
        // then join() them all together.
        const tableRows = data.map(store => `
          <tr>
            <td>${store.AI_STORENAME}</td>
            <td>${store.TotalStock}</td>
            <td>${store.Age_0_45_Days}</td>
            <td>${store.Age_46_90_Days}</td>
            <td>${store.Age_91_120_Days}</td>
            <td>${store.Age_120_Plus_Days}</td>
          </tr>
        `).join(''); // Join all row strings into a single block

        // Append the table structure with the generated rows
        html += `
          <div class="table-wrapper">
            <table id="inventoryTable">
              <thead>
                <tr>
                  <th>Store Name</th>
                  <th>Total Stock</th>
                  <th>0-45 Days</th>
                  <th>46-90 Days</th>
                  <th>91-120 Days</th>
                  <th>120+ Days</th>
                </tr>
              </thead>
              <tbody id="inventoryTableBody">
                ${tableRows}
              </tbody>
            </table>
          </div>
        </div>`;
      }

      return html;
    }
}
